import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const envApi = import.meta.env.VITE_APP_API_URL;
const VITE_APP_API_URL = (() => {
  if (envApi && envApi !== 'undefined') {
    const base = envApi.replace(/\/$/, '');
    return base.endsWith('/api') ? base : `${base}/api`;
  }
  return import.meta.env.DEV ? 'http://localhost:5000/api' : '/api';
})();

const api: AxiosInstance = axios.create({
  baseURL: VITE_APP_API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // If the data is FormData, remove Content-Type header so axios can set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Define public routes that should not redirect to login on 401
      const publicRoutes = [
        '/login',
        '/register/internal',
        '/register/external',
        '/reset-password',
        '/forgot-password',
      ];

      const dynamicPublicRoutes = ['/documents', '/booking'];

      const currentPath = window.location.pathname;

      const isStaticPublic = publicRoutes.includes(currentPath);

      const isDynamicPublic = dynamicPublicRoutes.some((prefix) =>
        currentPath === prefix || currentPath.startsWith(prefix + '/')
      );

      if (!isStaticPublic && !isDynamicPublic) {
        const redirectPath = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?redirect=${redirectPath}`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
